/**
 *
 */
import axios from 'axios';

const SEARCH_URL = '/api/search_release.php';

export const fetchReleaseList = (params) => {
  return axios(SEARCH_URL, {
    params: params
  }).then(response => {
    return response.data;
  }).then(data => {
    return data;
  }).catch(err => {
    throw err;
  });
};
